<div class="max-two-rows" [matTooltip]="data ? data.toString() : ''">
        {{ datePipeFormat && data ? (useRomeDatePipe() ? (data | romeDate: datePipeFormat : 'Europe/Rome') : (data | date: datePipeFormat : 'Europe/Rome')) : truncateWords(data) }}
        <!-- {{datePipeFormat && data ? (data | date: datePipeFormat : '+0:00') : truncate(data)}} -->
</div>